import React from 'react'
import {
  Grid,
  Dialog,
  Card,
  CardContent,
  Button,
  Box,
} from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

/**
 * Signup dialog component for public property pages
 * Shows when users try to access premium features
 */
const SignupDialog = ({ open, onClose  }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
    >
      <Card>
        <CardContent>
          <Box sx={{ textAlign: 'center', p: '3rem' }}>
            <Box sx={[{ borderRadius: '50%', m: 0 }, {
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              mr: "0.25rem",
              position: "relative",
              fontSize: "1.2rem",
              transition: "all 0.2s ease-in-out",
              "&:last-child": { mr: 0, marginRight: 0 },
              "& .badge": { position: "absolute", right: 0, bottom: 0 },
              "& svg, & .svg-inline--fa": { display: "block" },
              marginRight: "0.25rem",
            }]}>
              <Box style={{ backgroundColor: '#b3d7ff', color: '#008aff', }} sx={[{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                border: 0,
                height: "130px !important",
                width: "130px !important",
                lineHeight: "130px !important",
                p: 0,
                borderRadius: "50%",
                m: 0,
              }, {
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                mr: "0.25rem",
                position: "relative",
                fontSize: "1.2rem",
                transition: "all 0.2s ease-in-out",
                "&:last-child": { mr: 0, marginRight: 0 },
                "& .badge": { position: "absolute", right: 0, bottom: 0 },
                "& svg, & .svg-inline--fa": { display: "block" },
                marginRight: "0.25rem",
              }]}>
                <FontAwesomeIcon icon={['fas', 'user-plus']} style={{ display: 'flex', alignSelf: 'center' }} sx={{ fontSize: "3rem", fontWeight: "300", lineHeight: "1.2" }} />
              </Box>
            </Box>
            <Box
              component="h4"
              sx={{ fontWeight: 700, mt: '1.5rem' }}
            >
              Create account for full analysis!
            </Box>
            <Box component="p" sx={[{ mb: 0, color: '#a6a6b9' }, { fontSize: "1.15rem !important" }]}>
              Create account to see full analysis that includes ARV,
              comps, rehab, closing costs, projections, and so much
              more!
            </Box>
            <Box sx={{ pt: '1.5rem' }}>
              <Grid
                container
                direction="row"
                spacing={2}
                sx={{
                  justifyContent: 'space-around',
                }}
              >
                <Grid>
                  <Button variant="contained" sx={{
                    boxShadow: "0 0.25rem 0.55rem rgba(244, 119, 46, 0.35)",
                    color: "#fff",
                    backgroundColor: "#f4772e",
                    backgroundImage: "none",
                    borderColor: "#f4772e",
                    "&:not(:disabled):hover": { backgroundColor: "#f4772e", color: "#fff" },
                    "&:not(:disabled).active, &:not(:disabled).active:hover, &:not(:disabled):active": { backgroundColor: "#e35b0c" },
                    "&:not(:disabled):active": { boxShadow: "0 0.22rem 0.525rem rgba(244, 119, 46, 0.4), 0 0.0625rem 0.385rem rgba(244, 119, 46, 0.54)" },
                    "&:not(:disabled).active .btn-wrapper--icon svg path, &:hover .btn-wrapper--icon svg path": { fill: "#fff" },
                  }}>
                    Watch Demo
                  </Button>
                </Grid>
                <Grid>
                  <Button variant="contained" color="primary">
                    Plan Options
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </Dialog>
  )
}

export default SignupDialog
